module.exports = __webpack_public_path__ + "static/media/group.d916789c.png";